import React from 'react';
import Hero from '../component/Hero';

export default function Home() {
  return (
    <div>
      <Hero />
    </div>
  );
}
